import Instance from '../../../Axios';

const RemoverApartamento = (id) => async (dispatch) => {
  console.log(id);
  await Instance()
    .delete(`/backend/apartamentos/${id}`)
    .then(({ data }) => {
      dispatch({ type: 'DELETE_APARTAMENTO', payload: data });
    })
    .catch(({ err }) => console.log(err));
};

export default RemoverApartamento;
